<template>
  <div>
    <div class="header mb-4">
      <router-link :to="{ name: 'admin.types.create' }" class="btn bg-white float-end">Add New<i class="fal fa-plus me-0 ms-2"></i></router-link>
      <h1 class="header-title">Content Types</h1>
      <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <a href="#">Dashboard</a>
          </li>
          <li class="breadcrumb-item active" aria-current="page">Content Types</li>
        </ol>
      </nav>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body" v-if="! loading">
            <table class="table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Name</th>
                  <th>Added</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="types.length == 0">
                  <td colspan="5">There is no data to display.</td>
                </tr>
                <tr v-for="(type, i) in types" :key="`type-${i}`">
                  <td>{{ i+1 }}</td>
                  <td>{{ type.name }}</td>
                  <td>{{ type.created_at }}</td>
                  <td>
                    <router-link :to="{ name: 'admin.types.show', params: { id: type.id }}"><i class="fal fa-eye"></i>Details</router-link>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <loading v-if="loading" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    this.fetch()
  },

  data() {
    return {
      loading: true,
      types: []
    }
  },

  methods: {
    fetch() {
      this.loading = true

      this.$axios.get('/api/v1/admin/types').then(response => {
        this.types = response.data.types
        this.loading = false
      })
    }
  }
};
</script>